webpackJsonp([196846049502372],{

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex\n  align-items: center\n"], ["\n  display: flex\n  align-items: center\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-right: 30px\n  text-align: center\n  p {\n    font-size: 1.1rem\n  }\n"], ["\n  margin-right: 30px\n  text-align: center\n  p {\n    font-size: 1.1rem\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SponsorContainer = _styledComponents2.default.div(_templateObject);
	var SponsorLogo = _styledComponents2.default.div(_templateObject2);
	
	var SponsorTemplate = function SponsorTemplate(_ref) {
	  var data = _ref.data;
	
	  var node = data.nodeSponsors;
	  return _react2.default.createElement(
	    SponsorContainer,
	    null,
	    _react2.default.createElement(
	      SponsorLogo,
	      null,
	      _react2.default.createElement("img", { src: node.r.logo.localFile.childImageSharp.sizes.src, alt: node.title }),
	      _react2.default.createElement(
	        "p",
	        null,
	        "is a proud ",
	        node.level,
	        " sponsor!"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "sponsor-content" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        node.title
	      ),
	      _react2.default.createElement("div", {
	        dangerouslySetInnerHTML: { __html: node.body.processed }
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "sponsor-link" },
	        "For more information go to ",
	        _react2.default.createElement(
	          "a",
	          { href: node.link.uri },
	          node.link.uri
	        )
	      )
	    )
	  );
	};
	
	exports.default = SponsorTemplate;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-sponsor-js-750c2021dd551ff2ada6.js